export const DriverTypes = {
    driver: 'Driver',
    broker: 'Broker',
};
